import { useContext } from "react";
import { VGroveContext } from "../providers/VGroveContext";
import { useTheme, type ThemeMode, type ResolvedTheme } from './useTheme';

/**
 * 获取 VGrove 上下文
 */
export const useVGrove = () => {
    const context = useContext(VGroveContext);
    if (!context) {
        throw new Error('useVGrove must be used within a VGroveProvider');
    }
    return context;
};

/**
 * 获取当前布局设置
 */
export const useVGroveLayoutSettings = () => {
    const { settings } = useVGrove();
    return settings;
};

/**
 * 获取布局功能状态
 */
export const useLayoutFeatures = () => {
    const { features } = useVGrove();
    return features;
};

/**
 * 更新布局设置
 */
export const useUpdateLayoutSettings = () => {
    const { updateSettings } = useVGrove();
    return updateSettings;
};

/**
 * 重置布局设置为默认值
 */
export const useResetLayoutSettings = () => {
    const { resetSettings } = useVGrove();
    return resetSettings;
};

/**
 * 主题模式标签映射
 */
export const useThemeLabels = () => {
    return {
        light: '浅色',
        dark: '深色',
        auto: '跟随系统'
    } as const;
};

export { useTheme, type ThemeMode, type ResolvedTheme }; 